exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white;\n  color: dimgray;\n  padding-top: 1rem; }\n  .container .total-usuarios {\n    color: black; }\n  .container #date-input {\n    cursor: pointer; }\n    .container #date-input:-moz-read-only {\n      background-color: white; }\n    .container #date-input:read-only {\n      background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/advance-users/advance-users.component.scss
// module id = ../../../../../src/app/components/advance-users/advance-users.component.scss
// module chunks = main